<template>
	<ul>
		<li v-for="item in items" :key="item.filename">
			<nuxt-link :to="item.filename">
				{{ item.header }}
			</nuxt-link>
			<div v-if="item.children.length">
				<recursive-sitemap :items="item.children" />
			</div>
		</li>
	</ul>
</template>

<script setup lang="ts">
defineProps<{
	items: SitemapItem[];
}>();
</script>

<style lang="scss" scoped>
ul {
	padding: 5px 0 15px 20px;
	text-align: left;
	max-width: 300px;
	margin: 25px auto 0;
}
</style>
